import { Map } from 'immutable';

import { teamsMembersListActions } from '../teams-members-list';
import { teamsMemberActions } from './actions';
import { createExtendedMember, Member } from './teams-member';

export const initialState = new Map({});

export function teamsMembersReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case teamsMembersListActions.FETCH_TEAM_MEMBERS_LIST_SUCCESS:
      return state.withMutations(members => {
        payload.data.items.forEach(memberData => {
          members.set(`${memberData.user_id}`, createExtendedMember(memberData));
        });
      });

    case teamsMemberActions.FETCH_TEAM_MEMBERS_FAILED:
    case teamsMemberActions.FETCH_TEAM_MEMBERS_SUCCESS:
    case teamsMemberActions.FETCH_TEAM_MEMBERS_PENDING:
      return state.set(
        payload.teamsMemberId,
        teamsMemberReducer(state.get(payload.teamsMemberId), action)
      );

    default:
      return state;
  }
}

export const teamsMemberReducer = (state = new Member(), { payload, type }) => {
  switch (type) {
    case teamsMemberActions.FETCH_TEAM_MEMBERS_FAILED:
      return state.merge({
        isPending: false,
        error: payload.code
      });
    case teamsMemberActions.FETCH_TEAM_MEMBERS_SUCCESS:
      return createExtendedMember(payload.data);
    case teamsMemberActions.FETCH_TEAM_MEMBERS_PENDING:
      return state.set('isPending', true);

    default:
      return state;
  }
}
